// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"107":"0ec92362","971":"20645505"}[chunkId] + ".js";
};